import React from 'react';
import Row from 'react-bootstrap/Row';
import { useSpring, animated } from 'react-spring'
import Col from 'react-bootstrap/Col';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container';



//Half picture, half web dev explanation. Animation added. see data-aos

const calc = (x, y) => [-(y - window.innerHeight / 2) / 20, (x - window.innerWidth / 2) / 20, 1.1]
const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`

const buttonStyle = {
    marginTop: "20px",
    backgroundColor: "rgb(20, 150, 255)",
    outline: "none",
    padding: "20px",
    fontWeight: "500",
    borderRadius: "10px",
    color: "white"
}




function Product() {
    const [props, set] = useSpring(() => ({ xys: [0, 0, 1], config: { mass: 5, tension: 350, friction: 40 } }))
    return (
        <Container>
            <Row className="spacing" id="product" style={{marginBottom: "200px"}}>

            <Col md={6} style={{marginTop: "50px", marginRight: "auto", marginLeft: "auto"}}>
                    <animated.div
                        className="card cardImg3"
                        onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
                        onMouseLeave={() => set({ xys: [0, 0, 1] })}
                        style={{ transform: props.xys.interpolate(trans) }}
                    >
                    </animated.div>
                </Col>
                            
                <Col md={6} data-aos={"fade-up"} className="text-center" style={{marginTop: "5%"}}>
                    <div className="titleProcess2">Be impressed by what we can do.</div>
                    <div className="subProcess2">
                        Get started today by requesting a quote.
                    </div>
                    <Row className="noteSection">
                        <Col md={4} className="mobileSpaceingNote">
                            <div style={{textAlign: "left"}} className="subNoteTitle">
                                Design
                            </div>
                            <div style={{textAlign: "left"}} className="subNoteText">
                                We use Adobe XD to get our design started and we then share these designs with you to review.
                            </div>
                        </Col>
                        <Col md={4} className="mobileSpaceingNote">
                            <div style={{textAlign: "left"}} className="subNoteTitle">
                                Development
                            </div>
                            <div style={{textAlign: "left"}} className="subNoteText">
                                Our expertise weight heavily in the development phase, we can get things done fast and well.
                            </div>
                        </Col>
                        <Col md={4} className="mobileSpaceingNote">
                            <div style={{textAlign: "left"}} className="subNoteTitle">
                                Feedback
                            </div>

                            <div style={{textAlign: "left"}} className="subNoteText">
                                We value your opinion on the product. We offer unlimited revisions on the product until you are satisfied. 
                            </div>
                        </Col>
                    </Row>
                    <Link to='/contact' style={{marginTop: "30px"}}>
                        <Button variant="contained"  disableElevation style={buttonStyle}>
                            Contact Support
                        </Button>
                    </Link>
                </Col>


            </Row>
        </Container>
    )
  }



export default Product;